import {createApp} from "vue";
import App from "../vue/SpeakersList.vue";
import {createI18n} from "vue-i18n";
import Language from "../vue/Helpers/Language";
import ptLang from "../../languages/pt.json";
import enLang from "../../languages/en.json";

const app = createApp(App);

app.use(createI18n({
    allowComposition: true,
    locale: Language.getLanguage(),
    fallbackLng: 'pt-BR',
    messages: {
        'pt-BR': ptLang,
        'en-US': enLang,
    }
}));

app.mount('#speakers_list');
